import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router'
import { queryClient } from '../../../App'
import { getSuitableRequestsForServiceReports } from '../../../services/NewApiService'
import { CheckboxStore } from '../../../stores/CheckboxStore'
import NewPaginationStore from '../../../stores/NewPaginationStore'
import { getComp } from '../../../utils/utils/DI'

type ParamsType = {
  id?: string
  phoneNumber?: string
  dateOfMaintenanceFrom?: string
  dateOfMaintenanceTo?: string
  fullName?: string
  fullAddress?: string
  statuses?: number[]
  dataCheckingStatuses?: number[]
  ticketStatuses?: number[]
  isBinded?: boolean
}

const initParams: ParamsType = {}

export const addToServiceReportPaginationStore = new NewPaginationStore(
  initParams,
)

export const addToServiceReportCheckboxStore = new CheckboxStore()

export const useAddToServiceReportTableData = () => {
  const { reportId } = useParams()
  const {
    page,
    size,
    sort,
    params: {
      fullAddress,
      dateOfMaintenanceFrom,
      dateOfMaintenanceTo,
      fullName,
      id,
      phoneNumber,
      statuses,
      dataCheckingStatuses,
      ticketStatuses,
      isBinded,
    },
  } = addToServiceReportPaginationStore

  const userId = getComp('UserInfoStore')?.info?.id

  const enabled = !!userId || !!reportId || !!Number.isNaN(Number(reportId))

  return useQuery(
    {
      queryKey: [
        'add-requests-to-service-report-table',
        size,
        page,
        sort,
        fullAddress,
        dateOfMaintenanceFrom,
        dateOfMaintenanceTo,
        fullName,
        id,
        phoneNumber,
        statuses,
        dataCheckingStatuses,
        ticketStatuses,
        isBinded,
        userId,
        reportId,
      ],
      queryFn: () =>
        getSuitableRequestsForServiceReports(Number(reportId), {
          size,
          page,
          fullAddress,
          dateOfMaintenanceFrom,
          dateOfMaintenanceTo,
          fullName,
          id,
          phoneNumber,
          statuses,
          sort,
          dataCheckingStatuses,
          ticketStatuses,
        }),
      staleTime: 1000000,
      placeholderData: keepPreviousData,
      enabled: () => !!enabled,
    },
    queryClient,
  )
}
